import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import dateFormat from 'dateformat';
import BookLoader from './loaders/bookloader';
import htmlTruncate from 'html-truncate';
import './Blogs.css'; // Make sure to create this file

const Blogs = ({ showAll }) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/articles/`)
      .then((response) => response.json())
      .then((data) => {
        setBlogs(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching blogs:", error);
        setLoading(false);
      });
  }, []);

  const displayBlogs = showAll ? blogs : blogs.slice(0, 3);

  // Show loader while fetching
  if (loading) {
    return (
      <div className="loader-container">
        <BookLoader
          background={"linear-gradient(135deg, #6066FA, #fa6616)"}
          desktopSize={"100px"}
          mobileSize={"80px"}
          textColor={"#fa6616"}
        />
      </div>
    );
  }

  // Show message if no blogs found
  if (displayBlogs.length === 0) {
    return (
      <div className="text-center py-5">
        <p className="text-muted">No articles available at the moment.</p>
      </div>
    );
  }

  return (
    <section className={`blog-section ${showAll ? 'page-view' : ''}`}>
      <div className="container">
        
        {/* Section Header */}
        <div className="text-center mb-5">
          <h5 className="section-subtitle">Medical Insights</h5>
          <h2 className="section-title">{showAll ? "All Articles" : "Latest Updates"}</h2>
          <div className="title-underline"></div>
          <p className="section-desc">
            Regular updates and health tips from Dr. Sunil Apsingi regarding Orthopedics and Joint Care.
          </p>
        </div>

        <div className="row">
          {displayBlogs.map((blog) => (
            <div className="col-lg-4 col-md-6 mb-4 d-flex align-items-stretch" key={blog.id}>
              <div className="blog-card">
                
                {/* Image Container with Date Badge */}
                <div className="blog-img-wrapper">
                  <img
                    src={blog.poster || "https://via.placeholder.com/400x250?text=Medical+Article"}
                    alt={blog.title}
                    className="blog-img"
                  />
                  <div className="date-badge">
                    <span className="day">{dateFormat(blog.datetime, "dd")}</span>
                    <span className="month">{dateFormat(blog.datetime, "mmm")}</span>
                  </div>
                </div>

                <div className="blog-body">
                  <div className="blog-meta">
                    <span className="author">
                      <i className="fa fa-user-md me-1"></i> {blog.author || 'Dr. Sunil'}
                    </span>
                    <span className="separator">|</span>
                    <span className="specialist">{blog.specialist || 'Orthopedic'}</span>
                  </div>

                  <h5 className="blog-title">
                    <Link to={`/blogs/${blog.id}`} target="_blank" rel="noopener noreferrer">
                      {blog.title}
                    </Link>
                  </h5>

                  {/* Content Excerpt */}
                  <div 
                    className="blog-excerpt"
                    dangerouslySetInnerHTML={{ __html: htmlTruncate(blog.content, 100) }}
                  ></div>

                  <div className="blog-footer mt-auto">
                    <Link
                      to={`/blogs/${blog.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="read-more-btn"
                    >
                      Read Article <i className="fa fa-arrow-right ms-2"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button (Only on Home Page) */}
        {!showAll && (
          <div className="text-center mt-4">
            <Link to="/blogs" className="btn-view-all">
              View All Articles
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default Blogs;